import { render, staticRenderFns } from "./suiyidaiinfo.vue?vue&type=template&id=5f9535aa&scoped=true&"
import script from "./suiyidaiinfo.vue?vue&type=script&lang=js&"
export * from "./suiyidaiinfo.vue?vue&type=script&lang=js&"
import style0 from "./suiyidaiinfo.vue?vue&type=style&index=0&id=5f9535aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9535aa",
  null
  
)

export default component.exports